module.exports = __webpack_public_path__ + "static/media/pic1.63e5cf4e.jpg";